module.exports = __webpack_public_path__ + "static/media/taskr-app-thub.02426ca0.PNG";